import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const Size = Quill.import("formats/size");
Size.whitelist = ["small", "normal", "large", "huge"];
Quill.register(Size, true);

const fontSizeOptions = ["small", false, "large", "huge"]; // false là default

const modules = {
  toolbar: [
    [{ size: fontSizeOptions }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

interface TextEditorProps {
  value: string;
  onChange: (value: string) => void;
}

export default function TextEditor({ value, onChange }: TextEditorProps) {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      modules={modules}
      className="rounded-lg border border-[#E2E8F0] bg-white [&_.ql-container]:border-0 [&_.ql-editor]:min-h-[160px] [&_.ql-toolbar]:border-0 [&_.ql-toolbar]:border-b "
    />
  );
}
